import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { postOptimizelyExperiments } from '../api/api';

// TODO: a response that resolves after a logout or re-login still applies its experiment
// assignments, so login's fetchExperiments(userId) and logout's fetchExperiments() can land in
// either order. Drop late results when the session changed, as requestUserThunk does with
// userSessionGeneration in userSlice (would need the generation shared outside userSlice).
const fetchExperiments = createAsyncThunk(
  'experiments/fetchExperiments', async (userId, { getState }) => {
    const state = getState();
    const { resyLocations, user } = state;
    const resolvedUserId = userId ?? user?.userData?.id;
    const isP1City = resyLocations?.selected?.content_tier === 1;
    const payload = resolvedUserId
      ? {
        track_user_id: true,
        user_attributes: { platform: 'web', user_id: resolvedUserId, is_p1_city: isP1City },
      }
      : { track_user_id: false, user_attributes: { platform: 'web', is_p1_city: isP1City } };
    const response = await postOptimizelyExperiments(payload);
    return response;
  },
  {
    condition: (userId, { getState }) => {
      if (userId !== undefined) return true;

      const state = getState();
      return !state.authToken?.token || !!state.user?.userData?.id;
    },
  }
);

const defaultState = { loaded: false };

const experimentsSlice = createSlice({
  name: 'experiments',
  initialState: defaultState,
  reducers: {
    resetExperiments: () => defaultState,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchExperiments.fulfilled, (state, action) => {
      const experiments = action.payload;
      const result = { loaded: true };
      experiments.forEach((experiment) => {
        result[experiment.flag_key] = experiment;
      });
      return result;
    });
    builder.addCase(fetchExperiments.rejected, (state) => {
      state.loaded = true;
    });
  },
});

export { fetchExperiments };
export const { resetExperiments } = experimentsSlice.actions;
export default experimentsSlice.reducer;
